import { faTrash } from '@fortawesome/duotone-regular-svg-icons';

import theme from '~/theme/';

import QuestionLibraryButton from './QuestionLibraryButton';

type DeleteIconButtonProps = {
  onClick: (...args: any[]) => any;
  testId?: string;
  isDisabled?: boolean;
  sx?: any;
  label?: string;
  ariaLabel?: string;
};

export default function DeleteIconButton({
  onClick,
  testId = 'delete-icon-button',
  isDisabled = false,
  label = '',
  sx = {},
  ariaLabel,
}: Readonly<DeleteIconButtonProps>) {
  return (
    <QuestionLibraryButton
      ariaLabel={ariaLabel || label || 'Delete'}
      handleClick={() => onClick()}
      testId={testId}
      isDisabled={isDisabled}
      icon={faTrash}
      fontColor={theme.colors?.blue[600]}
      label={label}
      sx={sx}
    />
  );
}
